import { bridgeUrl } from "../lib/utils";

export interface IPayload {
  appId: string;
  idpContext: string;
  idpTypeId: string;
  idpQuery: string;
}

export const getPayloadWithSession = async (sessionId: string) => {
  const payloadResponse = await fetch(`${bridgeUrl()}/${sessionId}/payload`, {
    method: "GET",
  });

  const res = await payloadResponse.json();
  if (!payloadResponse.ok) {
    throw new Error(res.message || "Failed to fetch payload");
  }

  return res;
};

export const submitResponse = async (
  sessionId: string,
  iv: string,
  payload: string
) => {
  const responseResult = await fetch(`${bridgeUrl()}/${sessionId}/response`, {
    method: "POST",
    headers: {
      "content-type": "text/plain;charset=UTF-8",
    },
    body: JSON.stringify({
      iv,
      payload,
    }),
  });

  return responseResult;
};
